module.exports = __webpack_public_path__ + "static/media/for-partners.2be4ede7.png";